





















import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import User from '@/models/User';

@Component
export default class EmployerHome extends Vue {}
